import api from './api';

const assessmentService = {
  /**
   * Submit level test answers
   * @param {Array} answers - Array of answer objects
   * @returns {Promise<Object>} Test results with score and level
   */
  submitLevelTest: async (answers) => {
    const response = await api.post('/assessments/level-test', {
      answers,
    });
    return response.data;
  },

  /**
   * Get test results by ID
   * @param {string} testId - Test result ID
   * @returns {Promise<Object>} Test results
   */
  getTestResults: async (testId) => {
    const response = await api.get(`/assessments/results/${testId}`);
    return response.data;
  },

  /**
   * Get user's test history
   * @returns {Promise<Array>} Array of test results
   */
  getTestHistory: async () => {
    try {
      // Try the content endpoint first (new system)
      const response = await api.get('/content/assessment-results');
      return response.data;
    } catch (error) {
      // Fallback to old endpoint if content endpoint fails
      try {
        const response = await api.get('/assessments/results');
        return response.data;
      } catch (fallbackError) {
        console.error('Failed to fetch test history from both endpoints:', fallbackError);
        throw fallbackError;
      }
    }
  },

  /**
   * Generate content access token for iframe
   * @param {string} contentType - Type of content (assessment, course, etc.)
   * @param {string} contentId - ID of the content
   * @returns {Promise<Object>} Access token and content URL
   */
  generateAccessToken: async (contentType, contentId) => {
    const response = await api.post('/assessments/access-token', {
      content_type: contentType,
      content_id: contentId,
    });
    return response.data;
  },
};

export default assessmentService;